import {createModel} from '~~/package/utils/ModelUtil';
import Model from '~~/package/mapper/Model';
import {
    ProSkillAssureTemplateSetInfoModel
} from '~~/package/mapper/proSkillAssure/model/template/ProSkillAssureTemplateSetInfoModel';
import {UserStatusType} from '~~/package/mapper/user/model/UserStatusType';

export class ProSkillAssureTemplateModel extends Model {
    constructor(
        public id: number = 0,
        public title: string = "",
        public name: string = "",
        public userStatus: UserStatusType = UserStatusType.NORMAL,
        public assessmentSetInfoVOList: ProSkillAssureTemplateSetInfoModel[] = [],
        public createdAt: string = "",
        public timeZoneId: string = ""
    ) {
        super();
    }

    public static create(model: Partial<ProSkillAssureTemplateModel>): ProSkillAssureTemplateModel {
        return createModel<ProSkillAssureTemplateModel>(ProSkillAssureTemplateModel, {
            ...model
        });
    }
}
